class Circle {
  _state = {
    isScrolling: false,
    windowWidth: 0
  }

  options = {
    scrollTimeout: 66,
    minInterval: 1000,
    maxInterval: 3000,
    minXY: -80,
    maxXY: 80,
    mobileWidth: 720,
    divider: 2
  }

  constructor(element, options = {}) {
    this._options = { ...options, ...Circle.options }
    this._element = element
    this._scrollTimeOut = this._scrollTimeOut.bind(this)
    this._setWindowWidth = this._setWindowWidth.bind(this)
    this._init()
    this._cacheSelectors()
    this._addListeners()
  }

  _init() {
    this._setWindowWidth()
  }

  _cacheSelectors() {
    this._body = document.body
    this._circle = this._element.querySelector('.circle__inside')
  }

  _addListeners() {
    window.addEventListener('scroll', () =>
      window.requestAnimationFrame(this._scrollTimeOut)
    )
    window.addEventListener('resize', () =>
      window.requestAnimationFrame(this._setWindowWidth)
    )
  }

  _setWindowWidth() {
    this._state.windowWidth = window.innerWidth
  }

  _scrollTimeOut() {
    //eslint-disable-next-line
    this._state.isScrolling && window.clearTimeout(this._state.isScrolling)
    this._state.isScrolling = true

    this._state.isScrolling = setTimeout(() => {
      this._state.isScrolling = false
      this._moveCircles()
    }, this.options.scrollTimeout)
  }

  _moveCircles() {
    const t = setInterval(() => {
      //Reset styles to prevent jump
      this._circle.style.transform = getComputedStyle(this._circle).transform
      this._circle.style.WebkitTransform = getComputedStyle(
        this._circle
      ).transform
      //Change min and max depending on window size
      const max =
        this._state.windowWidth > this.options.mobileWidth
          ? this.options.maxXY
          : this.options.maxXY / this.options.divider
      const min =
        this._state.windowWidth > this.options.mobileWidth
          ? this.options.minXY
          : this.options.minXY / this.options.divider
      const x = Math.floor(Math.random() * max) + min
      const y = Math.floor(Math.random() * max) + min
      //Apply new coordinates
      this._circle.style.transform = `translate3d(${x}px, ${y}px, 0)`
      this._circle.style.WebkitTransform = `translate3d(${x}px, ${y}px, 0)`
      //Clear interval when not scrolling
      //eslint-disable-next-line
      this._state.isScrolling && clearInterval(t)
    }, Math.floor(Math.random() * this.options.maxInterval) + this.options.minInterval)
  }
}

export default Circle
